import React from 'react';
import block from 'bem-cn-lite';
import {Col, GridColumnSize, Row, Title} from '@yandex-data-ui/page-constructor';

import Anchor from 'components/Anchor/Anchor';
import {HTML} from '@doc-tools/components';

import './NavigationItemsTitle.scss';

const b = block('navigation-items-title');

export interface RenderTitleProps {
    name: string;
    description?: string | null;
    slug: string;
    url?: string;
    dataQa?: string;
    size?: string;
}

const NavigationItemsTitle: React.FC<RenderTitleProps> = ({
    name,
    description,
    slug,
    url,
    dataQa,
    size,
}) => {
    const isSizeM = size === 'm';
    return (
        <Row>
            <Col sizes={{[GridColumnSize.Md]: 9, [GridColumnSize.All]: 12}}>
                <Anchor id={slug} className={b('anchor')} />
                <Title
                    className={b()}
                    text={name}
                    textSize="s"
                    url={url}
                    dataQa={dataQa && `${dataQa}-title`}
                />
                {description && isSizeM && (
                    <HTML block={true} className={b('description')}>
                        {description}
                    </HTML>
                )}
            </Col>
        </Row>
    );
};

export default NavigationItemsTitle;
